module.exports = {
      id: "ic-basket-active-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-basket-active-usage",
      toString: function () {
        return this.url;
      }
    }